import mapboxgl from "mapbox-gl";
import { useEffect, useRef } from "react";
import { ISearchGeofence } from "Services/API/API";
import { setGeofencesData, initGeofencesLayer } from "Utils/MapGeofence";

function useSearchGeofenceMapFeatures(getMapbox: () => mapboxgl.Map, geofences: ISearchGeofence[]) {
   const geofenceRef = useRef(geofences);
   geofenceRef.current = geofences;

   useEffect(() => {
      const map = getMapbox();
      setGeofencesData(map, geofenceRef.current);
   }, [geofences]);

   useEffect(() => {
      const map = getMapbox();
      map.on("load", () => initGeofencesLayer(map, geofenceRef.current));
   }, []);
}

export default useSearchGeofenceMapFeatures;